import { InjectionToken } from '@angular/core';

export const CORE_CONFIG = new InjectionToken('coreConfig');

export function tokenGetter() {
    return localStorage.getItem('access_token');
}
